import React from 'react';
import ReportChart from '../../components/ReportChart';

const SessionReport: React.FC = () => {
  return <ReportChart />;
};

export default SessionReport; 